import React from 'react';
import { Route, Routes } from 'react-router-dom';

import BusinessInfo from './BusinessInfo';
import CreateAccount from './CreateAccount';
import CreatingAccountLoading from './CreateAccountLoading';
import Intent from './Intent';
import LoadingState from './LoadingState';
import Profile from './Profile';

// react-router v6 upgrade, no need to add the parent path "/trials"
export const TrialModalView = () => (
  <Routes>
    <Route element={<Profile />} path="profile" />
    <Route element={<BusinessInfo />} path="business-info" />
    <Route element={<CreatingAccountLoading />} path="creating-account" />
    <Route element={<Intent />} path="intent" />
    <Route element={<LoadingState />} path="loading" />
    <Route element={<CreateAccount />} path="*" />
  </Routes>
);

export default TrialModalView;
